module.exports = __webpack_public_path__ + "img/google_download.fb0c0d81.png";